import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useState } from 'react';
import { createProducts, createRoles } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import axios from 'axios'


const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showAddRolesDrawer: boolean;
    setShowAddRolesDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    getRoles: any
}
const AddRolesDrawer: React.FC<ProductsDrawerProps> = ({ showAddRolesDrawer, setShowAddRolesDrawer, getRoles }) => {
    const onCLose = () => setShowAddRolesDrawer(false)
    const [submitting, setSubmitting] = useState(false)
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate()



    const getClientIPAndURL = async () => {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const onFinish = (role: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.post('/api/v1/roles', role, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "Roles successfully added",
                    `${role.name} was added to the system`,
                    'topRight'
                )
            }
            getRoles()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }


    return <Drawer
        title="Create roles"
        width={720}
        onClose={onCLose}
        open={showAddRolesDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        style={{ backgroundColor: 'white' }}
        footer={
            <div
                style={{
                    textAlign: 'right',
                }}
            >
                <Button onClick={onCLose} style={{ marginRight: 8 }}>
                    Cancel
                </Button>
            </div>
        }
    >
        <Form layout="vertical"
            onFinishFailed={onFinishFailed}
            onFinish={onFinish}
            form={form}
            hideRequiredMark>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        name="name"
                        label="name"
                        rules={[{ required: true, message: 'Please enter name' }]}
                    >
                        <Input
                            placeholder="Please enter name"
                            className='focus:border-green-500 hover:border-green-500'
                        />
                    </Form.Item>
                </Col>

            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                            Submit
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                {submitting && <Spin indicator={antIcon} />}
            </Row>
        </Form>
    </Drawer>
}

export default AddRolesDrawer;


